export default __webpack_public_path__ + "static/media/MAN.e4e40e11.m4a";